import * as React from 'react';
import { forwardRef } from 'react';
import { Icon } from '@iconify/react';
import Box, { BoxProps } from '@mui/material/Box';
import { IconifyProps } from './types';

interface Props extends BoxProps {
  icon: IconifyProps;
  width?: number;
}

const Iconify = forwardRef<SVGElement, Props>(
  ({ icon, width = 20, sx, ...other }, ref) => (
    <Box
      ref={ref}
      className="component-iconify"
      sx={{ display: 'inline-flex', width, height: width, ...sx }} // Wrap Icon in Box
      {...other}
    >
      <Icon icon={icon} width={width} height={width} />
    </Box>
  )
);

export default Iconify;
